/**
 * Google Ads dönüşüm izleme — etkinlik snippet'i (AW hesabı).
 * İsteğe bağlı value/currency ile satış tutarı aktarılabilir.
 */
const SEND_TO = 'AW-1005240895/Q62GCO7EiZwcEL-Eq98D';

export function sendGoogleAdsConversion(options?: {
  value?: number;
  currency?: string;
}) {
  if (typeof window === 'undefined') return;
  const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag;
  if (typeof gtag !== 'function') return;
  gtag('event', 'conversion', {
    send_to: SEND_TO,
    value: options?.value ?? 1.0,
    currency: options?.currency ?? 'TRY',
  });
}
